<template>
  <div>
    <section>
      <b-card no-body class="shadow p-3 mb-5 bg-white rounded m-4">
        <div class="row">
          <!-- Sidebar untuk Tabs -->
          <div class="col-12 col-lg-2 mb-3">
            <!-- Loop through each main tab -->
            <div v-for="tab in tabs" :key="tab.tab">
              <div>
                  <!-- Main Tab Button -->
                  <b-button
                    block
                    :class="['btn-custom', { selected: selectedTab === tab.tab.replace(/\s/g, ''), disabled: tab.isDisabled }]"
                    :disabled="tab.isDisabled"
                    @click="!tab.isDisabled && (tab.children ? toggleSubTabs(tab.tab) : selectTab(tab.tab.replace(/\s/g, '')))"
                    v-if="tab.pic == 0 || tab.pic == 1 && items.data.mitra && items.data.mitra.id == items.data.mitra.mitra_id || tab.pic == 2 && items.data.mitra && items.data.mitra.id != items.data.mitra.mitra_id"
                  >
                    <div class="tab-content">
                      <span class="tab-text">{{ tab.tab }}</span>
                      <span v-if="tab.notif > 0" class="notification-dot">{{ tab.notif }}</span>
                    </div>
                  </b-button>


                  <!-- Sub-tabs -->
                  <div v-if="showSubTabs && activeParentTab === tab.tab && tab.children" class="sub-tabs">
                    <b-button
                      v-for="subTab in tab.children"
                      :key="subTab.tab"
                      block
                      :class="['btn-custom-sub', { selected: selectedTab === subTab.component, disabled: subTab.isDisabled }]"
                      @click="!subTab.isDisabled && selectTab(subTab.component)"
                      :disabled="subTab.isDisabled"
                    >
                      <div class="tab-content">
                        <span class="tab-text">{{ subTab.tab }}</span>
                        <span v-if="subTab.notif > 0" class="notification-dot">{{ subTab.notif }}</span>
                      </div>
                    </b-button>
                  </div>
              </div>
            </div>

            <!-- Profile Card -->
            <b-card v-if="items.data && items.data.mitra_profile" class="shadow p-3 mb-4 bg-white rounded m-4">
              <div class="row align-items-center">
                <div class="col-auto">
                  <template v-if="items.data.mitra_profile.logo_mitra">
                    <b-img 
                      :src="`${items.data.mitra_profile.logo_mitra}`" 
                      alt="Logo Perusahaan" 
                      class="img-fluid">
                    </b-img>
                  </template>
                  <template v-else>
                    <div class="border" style="padding: 10px; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc;">
                      <span>Logo Belum Ada</span>
                    </div>
                  </template>
                </div>
                <div class="col">
                  <h5 class="mb-0">{{ items.data.mitra_contact.nama_organisasi_perusahaan }}</h5>
                  <small>{{ items.data.mitra.name }}</small>
                </div>
              </div>
            </b-card>
          </div>

          <!-- Content untuk Tab yang Dipilih -->
          <div class="col-12 col-lg-10">
            <keep-alive>
              <component :is="selectedTab"></component>
            </keep-alive>
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
import Dashboard from "../components/dashboard/dashboard-index.vue";
import ManajemenProduk from "../components/dashboard/manajemen-produk.vue";
import ManajemenPembiayaan from "../components/dashboard/manajemen-pembiayaan.vue";
import ProfilMitra from "../components/dashboard/profil-mitra.vue";
import ManajemenPengajuan from "../components/dashboard/manajemen-pengajuan.vue";
import ManajemenPengajuanCorporate from "../components/dashboard/manajemen-pengajuan-corporate.vue";
import ManajemenPengajuanLending from "../components/dashboard/manajemen-pengajuan-lending.vue";
import PengajuanMasuk from "../components/dashboard/pengajuan-masuk.vue";
import PengajuanMasukCorporate from "../components/dashboard/pengajuan-masuk-corporate.vue";
import PengajuanLendingMasuk from "../components/dashboard/pengajuan-lending-masuk.vue";
import ProdukForm from "../public/dashboard/product-form.vue";
import UbahPassword from "../components/dashboard/ubah-password.vue";
import VerifikasiEmail from "../components/dashboard/verifikasi-email.vue";
import DaftarNasabah from "../components/dashboard/daftar-funder.vue";
import DaftarNasabahCorporate from "../components/dashboard/daftar-funder-corporate.vue";
import BiayaJasa from "../components/dashboard/biaya-jasa.vue";
import RekeningKorespondensi from "../components/dashboard/rekening-korespondensi.vue";
import KonfirmasiPembayaran from "../components/dashboard/konfirmasi-pembayaran.vue";
import DokumenPendukung from "../components/dashboard/dokumen-pendukung.vue";
import MitraProfile from "../api/mitraprofile";
import KonfirmasiPengembalianBilyet from "../components/dashboard/konfirmasi-pengembalian-bilyet.vue";

export default {
  name: "dashboard",
  data() {
    return {
      items: {},
      apiUrl: process.env.API_URL,
      tabs: [
        { tab: "Dashboard", notif: 0, isDisabled: false, pic: 0 },
        { tab: "Pengajuan Masuk", notif: 0, isDisabled: false, pic: 2,
          children: [
            // { tab: "Pembiayaan", component: "PengajuanLendingMasuk", notif: 0, isDisabled: false },
            // { tab: "Deposito/Tabungan", component: "PengajuanMasuk", notif: 0, isDisabled: false },
            { tab: "Perorangan", component: "PengajuanMasuk", notif: 0, isDisabled: false },
            { tab: "Badan Hukum", component: "PengajuanMasukCorporate", notif: 0, isDisabled: false },
          ] 
        },
        { 
          tab: "Manajemen Pengajuan", 
          notif: 0, 
          isDisabled: false, 
          pic: 1,
          children: [
            // { tab: "Pembiayaan", component: "ManajemenPengajuanLending", notif: 0, isDisabled: false },
            // { tab: "Deposito/Tabungan", component: "ManajemenPengajuan", notif: 0, isDisabled: false },
            { tab: "Perorangan", component: "ManajemenPengajuan", notif: 0, isDisabled: false },
            { tab: "Badan Hukum", component: "ManajemenPengajuanCorporate", notif: 0, isDisabled: false },
          ] 
        },
        {
          tab: "Konfirmasi",
          notif: 0,
          isDisabled: false,
          pic: 2,
          children: [
            { tab: "Konfirmasi Pembayaran", component: "KonfirmasiPembayaran", notif: 0, isDisabled: false },
            { tab: "Konfirmasi Pengembalian Bilyet", component: "KonfirmasiPengembalianBilyet", notif: 0, isDisabled: false }
          ]
        },
        { tab: "Dokumen Pendukung", notif: 0, isDisabled: false, pic: 2 },
        { tab: "Manajemen Produk", 
          notif: 0, 
          isDisabled: false, 
          pic: 1,
          children: [
            // { tab: "Pembiayaan", component: "ManajemenPembiayaan", notif: 0, isDisabled: false },
            { tab: "Deposito/Tabungan", component: "ManajemenProduk", notif: 0, isDisabled: false },
          ] 
        },
        { tab: "Daftar Nasabah", notif: 0, isDisabled: false, pic: 0,
          children: [
            { tab: "Perorangan", component: "DaftarNasabah", notif: 0, isDisabled: false },
            { tab: "Badan Hukum", component: "DaftarNasabahCorporate", notif: 0, isDisabled: false }
          ]
         },
        { tab: "Biaya Jasa", notif: 0, isDisabled: false, pic: 2 },
        { tab: "Rekening Korespondensi", notif: 0, isDisabled: false, pic: 0 },
        { tab: "Profil Mitra", notif: 0, isDisabled: false, pic: 0 }
      ],
      selectedTab: "Dashboard",
      showSubTabs: false,
      activeParentTab: null,
    };
  },
  mounted() {
    const savedTab = localStorage.getItem("selectedTab");
    if (savedTab) {
      this.selectedTab = savedTab;

      const parent = this.findParentTab(this.selectedTab);
      if (parent) {
        this.activeParentTab = parent;
        this.showSubTabs = true;
      } else {
        this.showSubTabs = false;
      }
    }
    this.loadData();
  },
  components: {
    Dashboard,
    ManajemenProduk,
    ManajemenPembiayaan,
    ProfilMitra,
    PengajuanMasuk,
    PengajuanMasukCorporate,
    ManajemenPengajuan,
    ManajemenPengajuanCorporate,
    ProdukForm,
    UbahPassword,
    VerifikasiEmail,
    DaftarNasabah,
    BiayaJasa,
    RekeningKorespondensi,
    KonfirmasiPembayaran,
    KonfirmasiPengembalianBilyet,
    DokumenPendukung,
    ManajemenPengajuanLending,
    PengajuanLendingMasuk,
    DaftarNasabahCorporate
  },
  methods: {
    async loadData() {
      try {
          // Ambil data profil mitra
          const mitraResponse = await MitraProfile.mitraProfile();
          this.items = mitraResponse.data;

          // Ambil data notifikasi
          const notifResponse = await MitraProfile.countsNotif();
          const countsNotif = notifResponse.data.data;

          // Perbarui notifikasi dan status disabled untuk setiap tab
          this.tabs.forEach(tab => {
              const tabKey = tab.tab.replace(/\s/g, '_').toLowerCase();
              
              // Untuk tab utama tanpa sub-tabs
              if (!tab.children) {
                  const tabData = countsNotif[tabKey] || {}; // Default ke objek kosong jika undefined
                  tab.notif = tabData.count || 0;          // Default ke 0 jika undefined
                  tab.isDisabled = tabData.is_disabled || false; // Default ke false jika undefined
              }

              // Untuk tab dengan sub-tabs
              if (tab.children) {
                  tab.children.forEach(subTab => {
                      const subTabKey = subTab.tab.replace(/\s/g, '_').toLowerCase();
                      const subTabData = countsNotif[subTabKey] || {}; // Default ke objek kosong jika undefined
                      subTab.notif = subTabData.count || 0;            // Default ke 0 jika undefined
                      subTab.isDisabled = subTabData.is_disabled || false; // Default ke false jika undefined
                  });

                  // Hitung total notifikasi sub-tabs untuk parent tab
                  const totalSubNotif = tab.children.reduce((sum, subTab) => sum + (subTab.notif || 0), 0);
                  tab.notif = totalSubNotif;

                  // Parent tab di-disable jika semua sub-tabs di-disable
                  tab.isDisabled = tab.children.every(subTab => subTab.isDisabled);
              }
          });
      } catch (error) {
          console.error("Error loading data:", error);
      }
    },
    updateSelectedTab(tabName) {
      this.selected = tabName;
      localStorage.setItem("selectedTab", tabName); // Simpan tab ke localStorage
    },
    getTabIcon(tabName) {
      const iconMap = {
        "Dashboard": "fas fa-home",
        "Pengajuan Masuk": "fas fa-inbox",
        "Manajemen Pengajuan": "fas fa-tasks",
        "Konfirmasi Pembayaran": "fas fa-credit-card",
        "Dokumen Pendukung": "fas fa-file-alt",
        "Manajemen Produk": "fas fa-box",
        "Daftar Funder": "fas fa-users",
        "Biaya Jasa": "fas fa-money-bill",
        "Rekening Korespondensi": "fas fa-university",
        "Profil Mitra": "fas fa-user-circle",
      };
      return iconMap[ tabName ] || "fas fa-folder";
    },
    toggleSubTabs(tab) {
      if (this.activeParentTab === tab) {
        this.showSubTabs = !this.showSubTabs;
      } else {
        this.activeParentTab = tab;
        this.showSubTabs = true;
      }
    },
    selectTab(tabName) {
      this.selectedTab = tabName;
      if (['KonfirmasiPembayaran', 
      'KonfirmasiPengembalianBilyet', 
      'ManajemenPembiayaan', 
      'ManajemenProduk', 
      'ManajemenPengajuanLending', 
      'ManajemenPengajuan', 
      'ManajemenPengajuanCorporate', 
      'DaftarNasabahCorporate', 
      'DaftarNasabah',
      'PengajuanMasuk',
      'PengajuanMasukCorporate',
    ].includes(this.selectedTab)) {
        this.showSubTabs = true;
      } else {
        this.showSubTabs = false;
      }
      localStorage.setItem("selectedTab", tabName);
    },
    findParentTab(childComponent) {
      for (const tab of this.tabs) {
        if (tab.children && tab.children.some(sub => sub.component === childComponent)) {
          return tab.tab;
        }
      }
      return null;
    }
  }
};
</script>

<style scoped>
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border: none;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  margin-top: 10px;
}

.btn-custom:hover {
  background-color: #d9a12e;
}

.selected {
  background-color: #274c8f !important;
  color: white;
  border-radius: 20px;
}

.sub-tabs {
  margin-top: 0.5rem;
  margin-left: 1.5rem;
}

.btn-custom-sub {
  background-color: #f6bc3c;
  color: #274c8f;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  border-radius: 15px;
  text-align: left;
}

.btn-custom-sub.selected {
  background-color: #274c8f !important;
  color: white;
}

/* Flex container for button content */
.tab-content {
  display: flex;
  align-items: center;
  width: 100%;
}

/* Text styling, aligned to the left */
.tab-text {
  flex-grow: 1;
  text-align: left;
  font-weight: 500;
}

/* Notification Dot styling */
.notification-dot {
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-left: auto;
}
.btn-custom.disabled,
.btn-custom-sub.disabled {
  background-color: #d6d6d6 !important;
  color: #a0a0a0 !important;
  cursor: not-allowed;
}

.btn-custom.disabled:hover,
.btn-custom-sub.disabled:hover {
  background-color: #d6d6d6;
  color: #a0a0a0;
}

</style>



// WEBPACK FOOTER //
// src/public/dashboard-mitra.vue